import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import TruckKanbanService from '../../../services/TruckKanbanService';

const ItemsXdSelect = (props) => {
    return (
        <div>
            {props.labels.map((item, index) => {
                return (
                    <div
                        style={{ display: 'block', padding: '10px', height: 'auto' }}
                        key={`oi-${index}`}
                    >
                        <span className="title sixth-text-color right">
                            <i onClick={() => props.removeLabel(item)} className="mdi mdi-close"></i>
                        </span>
                        <div>
                            <span className="sixth-text-color" style={{ display: 'block' }}>{item.id} - {item.partNumberCode}-{item.partNumberDescription} </span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        labels: state.truckKanbanReducer.labels
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        removeLabel: (label) => {
            dispatch(TruckKanbanService.removeLabel(label));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ItemsXdSelect));